import * as React from 'react';

import { Header } from 'layouts/SignUpTemplate/components/Header';
import { CreateCompanyPayload } from 'services/clients/user';
import { Other } from './components/Other';
import { Shippers } from './components/Shippers';
import { determineFlow } from '../utility';

interface DetailFormValues {
  volume: number;
  portCollections?: string[];
}

interface Props {
  submit: (values: DetailFormValues) => Promise<void>;
  companyType: CreateCompanyPayload['company_type_detail'];
}

export const CompanyDetails: React.FC<Props> = (props) => {
  const { submit, companyType } = props;

  let inner = null;
  switch (determineFlow(companyType)) {
    case 'shipper':
      inner = <Shippers submit={submit} />;
      break;
    case 'trucker':
    default:
      inner = <Other submit={submit} />;
      break;
  }

  return (
    <div className="w-full max-w-[768px] space-y-16">
      <Header header="Tell us more about your company!" />
      {inner}
    </div>
  );
};
CompanyDetails.displayName = 'CreateCompany.CompanyDetails';
